import {
  getSourceMetadataSlugBySourceSettingsSlug,
  getIntegrationMetadataByName,
  getActiveWorkspaceSlug
} from 'selectors'
import getProp from '@f/get-prop'

export const getSimulatorSource = state => state.application.simulator.source
export const getSimulatorIntegration = state => state.application.simulator.integration
export const getSimulatorMethod = state => state.application.simulator.method
export const getSimulatorPayload = state => state.application.simulator.payload
export const getSimulatorPayloadError = state => state.application.simulator.payloadError
export const getSimulatorActiveTab = state => state.application.simulator.activeTab
export const getSimulatorWriteKey = state => state.application.simulator.writeKey
export const getSimulatorResponse = state => state.application.simulator.response
export const isSimulatingEvent = state => state.application.simulator.isSendingEvent
export const didFailToSimulateEvent = state => state.application.simulator.didError
export const isShowingSimulatorAcknowledgeModal = state => state.application.simulator.isShowingAcknowledgeModal
export const isShowingSimulatorSendConfirmModal = state => state.application.simulator.isShowingSendConfirmModal
export const isShowingSimulatorSourceRequiredError = state => state.application.simulator.isShowingSourceRequiredError
export const getSimulatorMetadataSlugs = state => {
  const workspaceSlug = getActiveWorkspaceSlug(state)
  const sourceSettingsSlug = getProp('application.simulator.source', state)
  const sourceMetadataSlug = getSourceMetadataSlugBySourceSettingsSlug(state, workspaceSlug, sourceSettingsSlug)

  const simulatorIntegrationName = getSimulatorIntegration(state)
  const integrationMetadata = getIntegrationMetadataByName(state, simulatorIntegrationName)

  return {
    sourceMetadataSlug,
    integrationMetadataSlug: integrationMetadata.slug
  }
}



// WEBPACK FOOTER //
// ./selectors/simulator.js